import React, { useState } from 'react';
import './App.css';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CssBaseline from '@mui/material/CssBaseline';
import { TravelExplore } from '@mui/icons-material';
import axios from 'axios'
import { ThemeProvider, createTheme } from '@mui/material/styles';

function App() {
  const [feed, setFeed] = useState('');

  const [data, setData] = useState({});

  const getFeed = async () => {
    const res = await axios.get(`https://dashboard-api.audiomeans.fr/check-feed?feed=${encodeURIComponent(feed)}`);
    setData(res.data);
  }

  const theme = createTheme({
    palette: {
      mode: 'dark',
    }
  });

  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <div className="App">
          <div style={{
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}>
            <div style={{
              display: 'flex',
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: 'column',
              maxHeight: '300px'
            }}>
              <FormControl sx={{}} variant="filled" style={{ width: '80%' }}>
                <InputLabel htmlFor="outlined-adornment-password">Flux RSS</InputLabel>
                <FilledInput
                  id="outlined-adornment-password"
                  type={'text'}
                  value={feed}
                  fullWidth
                  onChange={(e) => setFeed(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={getFeed}
                        onMouseDown={() => { }}
                        edge="end"
                      >
                        {<TravelExplore />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label=""
                />
              </FormControl>

              {data?.title ? (
                <>
                  <div style={{ color: '#fff' }}>
                    Titre du podcast : {data?.title}
                  </div>
                  <div style={{ color: '#fff' }}>
                    L'adresse du propriétaire de ce podcast est :
                    <div style={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>{data?.email}</div>
                  </div>
                  <div style={{ color: '#fff' }}>
                    NB : {feed.indexOf('audiomeans.fr') === -1 && (data?.responseUrl || '').indexOf('feeds.audiomeans.fr') > -1 ? `une redirection vers Audiomeans a été detectée` : `aucune redirection du flux n'a été detéctée`}
                  </div>
                </>
              ) : (
                <div style={{ color: '#fff' }}>
                  Commencer par entrer un flux ci-dessus
                </div>
              )}
            </div>
          </div>
        </div>
      </ThemeProvider>
    </>
  );
}

export default App;
